export const BACKGROUND_TASKS_FLAG = 'DSN-922-background-task-progress'

export const BACKGROUND_TASK_KINDS = {
  EXPORT_PDF: 'export-pdf',
  EXPORT_IMAGE: 'export-image',
  EXPORT_EXCEL: 'export-excel',
}

// Untranslated keys: translated at render time so a mid-task language switch re-labels the card.
export const BACKGROUND_TASK_COPY = {
  [BACKGROUND_TASK_KINDS.EXPORT_PDF]: {
    extension: 'pdf',
    iconName: 'system-file-pdf',
    runningCaption: 'Preparing your PDF…',
    failedDescription: 'Couldn’t create your PDF.',
  },
  [BACKGROUND_TASK_KINDS.EXPORT_IMAGE]: {
    extension: 'zip',
    iconName: 'system-file',
    runningCaption: 'Preparing your images…',
    failedDescription: 'Couldn’t create your images.',
  },
  [BACKGROUND_TASK_KINDS.EXPORT_EXCEL]: {
    extension: 'xlsx',
    iconName: 'system-file-xls',
    runningCaption: 'Generating report…',
    failedDescription: 'Couldn’t create your report.',
  },
}

export const EXPORT_TYPE_TO_BACKGROUND_TASK_KIND = {
  pdf: BACKGROUND_TASK_KINDS.EXPORT_PDF,
  image: BACKGROUND_TASK_KINDS.EXPORT_IMAGE,
  excel: BACKGROUND_TASK_KINDS.EXPORT_EXCEL,
}

export const RATED_CARD_DISMISS_DELAY_MS = 1200

export const COURSE_CONVERSION_TASK_FLAG = 'RPRT-459-conversion-progress-card'

// Same limit as aha-elearning's ASSISTANT_CONVERSION_QUIET_LIMIT_MS: a run with no progress report and no
// course change for this long is shown as failed.
export const COURSE_CONVERSION_QUIET_LIMIT_MS = 10 * 60 * 1000

export const COURSE_CONVERSION_RATING_SOURCE = 'elearning_course_conversion'
